import React, {Component} from "react"
import PropTypes from "prop-types"

import Card from "@irati/ui/src/Layout/Card"
import Form from "@irati/ui/src/Form"
import Loading from "@irati/ui/src/Loading"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {H1, Body} from "@irati/ui/src/Typography"
import HR from "@irati/ui/src/Layout/Hr"
import {changePassword} from "@irati/auth/services/password"
import PasswordSavedModal from "@irati-web/platform/src/components/PasswordSavedModal/PasswordSavedModal"
import History from "@irati/utils/history"
import authentication from "@irati/auth"
import {Password} from "@irati-web/fields/user"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import SetPasswordError from "@irati/ui/src/SetPasswordError"
import Flex from "@irati/ui/src/Flex"

interface Props extends InjectIntl {}

interface State {
  oldPassword?: string
  newPassword?: string
  confirmPassword?: string
  load?: Promise<any>
  saved: boolean
}

class UpdateUserPassword extends Component<Props, State> {
  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    saved: false
  }

  handleChange = (label: "oldPassword" | "newPassword" | "confirmPassword", value?: string) => {
    this.setState({
      [label]: value,
      load: undefined
    })
  }

  handleSubmit = () => {
    const {oldPassword, newPassword} = this.state
    const user = authentication.user()

    if (!oldPassword || !newPassword) return

    const load = changePassword(user, oldPassword, newPassword).then(() => {
      this.setState({
        saved: true
      })
      setTimeout(() => {
        this.setState({
          saved: false
        })
        History.replace(
          {
            pathname: "/profile"
          },
          this.context
        )
      }, 3000)
    })

    this.setState({load})
  }

  handleHide = () => {
    this.setState({saved: false})
  }

  render() {
    const {oldPassword, newPassword, confirmPassword, load, saved} = this.state
    const {formatMessage} = this.props
    const {showPasswordLogin} = authentication.business()

    if (!showPasswordLogin) {
      return (
        <Card tiny noBorder>
          <H1>
            <FormattedMessage id="account.password.ssoHeader" />
          </H1>
          <HR />
          <Body>
            <FormattedMessage id="account.password.ssoText1" />
          </Body>
          <Body>
            <FormattedMessage id="account.password.ssoText2" />
          </Body>
        </Card>
      )
    }

    return (
      <Card tiny noBorder>
        <H1 marginBottom={4}>
          <FormattedMessage id="account.password.headerTwo.changePassword" />
        </H1>
        <Flex direction="column" maxWidth="480px" justifyContent="flex-start">
          <Form>
            <Password
              name="old-password"
              label={formatMessage({id: "account.password.fields.current.label"})}
              placeholder={formatMessage({id: "account.password.fields.current.placeholder"})}
              value={oldPassword}
              noValidation
              isRequired
              onChange={(value) => this.handleChange("oldPassword", value)}
            />
            <Password
              name="new-password"
              label={formatMessage({id: "account.password.fields.new.label"})}
              placeholder={formatMessage({id: "account.password.fields.new.placeholder"})}
              value={newPassword}
              hint={formatMessage({id: "platform.password.hint"})}
              onChange={(value) => this.handleChange("newPassword", value)}
            />
            <Password
              name="confirmPassword"
              label={formatMessage({id: "account.password.fields.confirm.label"})}
              placeholder={formatMessage({id: "account.password.fields.confirm.placeholder"})}
              value={confirmPassword}
              onChange={(value) => this.handleChange("confirmPassword", value)}
              passwordToMatch={this.state.newPassword}
            />
            <Loading load={load} useLoader={false} />
            <Loading load={load} Error={SetPasswordError} useLoader={false} />
            <ValidationButton large primary load={load} onClick={this.handleSubmit} marginTop={1}>
              <FormattedMessage id="account.password.changeButton" />
            </ValidationButton>
          </Form>
        </Flex>
        {saved && <PasswordSavedModal onHide={this.handleHide} />}
      </Card>
    )
  }
}

export default injectIntl(UpdateUserPassword)
